<template lang='pug'>
.introduceDetail-container(v-show='!bookMarksLoading')
    .introduce-container
        Product.item(
            v-for='(item, index) in data',
            :key='index',
            :bigName='introduceName',
            :smallName='item.name',
            :params='{ introduceId: introduceId, introduceId2: item.sid }',
            :img='item.bigImg',
            name='introduceDetail2',
            type='shoucang'
        ) 
    Icon.download(
        name='资料下载',
        height='0.85rem',
        src='资料下载@3x.png',
        v-if='pdfList.length != 0'
    )
    InformationDownload.list(
        v-for='item in pdfList',
        :key='item.pdfName',
        :link='item.pdfLink',
        type='shoucang',
        :name='item.pdfName'
        :id='item.id'
        :hId="introduceId"
    )
</template>

<script>
import Product from './components/product'
import InformationDownload from './components/informationDownload'
import Icon from './components/icon'
import { mapState } from 'vuex'
import { getDataRows, concatWithSymbol } from '@custouch/proxy-use'
import { getCmsStr, getPath } from './levelTitle'
export default {
    name: 'introduceDetail',
    props: ['introduceId'],
    components: {
        Icon,
        InformationDownload,
        Product,
    },
    data() {
        return {
            data: [],
            pdfList: [],
            introduceName:'',
        }
    },
    computed: {
        ...mapState(['bookMarks', 'bookMarksLoading','memberInfo']),
    },
    async created() {
        const { template } = window.env.VITE_DATA
        const [detail, pdfParam, {path}] = await Promise.all([getDataRows({dataTemplateId:template.product, dataHierarchyId: this.introduceId, index: 1, size: 99}),getDataRows({dataTemplateId:template.pdfData, dataHierarchyId: this.introduceId, index: 1, size: 99}),getPath(this.introduceId,this.$route.meta.mId)])
        const data = detail.data
        this.introduceName = data[0] ? data[0].detail.title : ''
        this.data = data.reduce((pre,cur)=>{
            pre.push(Object.assign({sid:cur.id},cur.detail))
            return pre
        },[])
        const cms = getCmsStr({mId: this.$route.meta.mId,hId: this.introduceId})
        this.$root.$emit('pageview',{title:concatWithSymbol([this.$route.meta.title,path]),cms})
        this.$root.$emit('updateShare', {
            title: this.introduceName + '-' + document.title,
        })
        this.$root.$emit('action', {
            name: this.$route.name,
            introduceName: this.introduceName,
        })
        const pdfList = pdfParam.data
        const dic = {}
        this.pdfList = pdfList.reduce((pre,cur)=>{
            if(!dic[cur.detail.pdfName]){
                // pre.push(cur.detail)
                pre.push(Object.assign(cur.detail,{id: cur.id}))
                dic[cur.detail.pdfName] = true
            }
            return pre
        },[])
    },
}
</script>

<style scoped lang='less'>
.introduceDetail-container {
    padding: 0rem 1rem 0 1rem;
    .download {
        margin-bottom: 0.8rem;
        margin-top: 1.2rem;
        font-weight: 700;
    }
    .introduce-container {
        .item {
            margin-bottom: 0.6rem;
        }
    }
}
.list {
    margin-bottom: 0.6rem;
}
</style>